import * as React from 'react';
import { Segmented } from './table';

/* Sub-page tab row under the page title. Real links, so ⌘-click works. */

export interface SubNavItem {
    id: string;
    label: string;
    href: string;
    count?: number;
}

export function SubNav({
    items,
    active,
    onSelect,
    label = 'Sections',
}: {
    items: SubNavItem[];
    active: string;
    /** in-page switch (plain click); ⌘/ctrl-click still follows href */
    onSelect?: (id: string) => void;
    label?: string;
}) {
    return (
        <nav className="subnav" aria-label={label}>
            {items.map((item) => (
                <a
                    key={item.id}
                    href={item.href}
                    className={item.id === active ? 'on' : undefined}
                    aria-current={item.id === active ? 'page' : undefined}
                    onClick={(e) => {
                        if (!onSelect || e.metaKey || e.ctrlKey) return;
                        e.preventDefault();
                        onSelect(item.id);
                    }}
                >
                    {item.label}
                    {item.count !== undefined && (
                        <span className="ct">{item.count}</span>
                    )}
                </a>
            ))}
        </nav>
    );
}

/** Page title + subtitle with actions on the right. */
export function PageHeadActions({
    title,
    sub,
    actions,
}: {
    title: React.ReactNode;
    sub?: React.ReactNode;
    actions?: React.ReactNode;
}) {
    return (
        <div className="phead">
            <div className="phead-t">
                <h1 className="pg-title">{title}</h1>
                {sub && <p className="pg-sub">{sub}</p>}
            </div>
            {actions && <div className="phead-a">{actions}</div>}
        </div>
    );
}

/** List / Calendar / Board … — which view of a page's records. */
export function ViewSwitch<T extends string>({
    value,
    options,
    onChange,
}: {
    value: T;
    options: Array<{ value: T; label: string }>;
    onChange: (v: T) => void;
}) {
    return (
        <span className="viewsw">
            <Segmented label="View" options={options} value={value} onChange={onChange} />
        </span>
    );
}
